<div class="flex items-center gap-4">
  <img
    class="h-12"
    src="/assets/integrations/heidi-square.jpg"
    alt="Heidi Health"
  />
  <div class="flex flex-col gap-1">
    <p class="!m-0 text-sm text-gray-600">
      AI-powered clinical note-taking for healthcare professionals.
    </p>
    <a
      class="text-primary-500 flex items-center gap-1 text-sm hover:underline"
      target="_blank"
      [href]="heidiSignupUrl"
    >
      Sign up for Heidi
      <mat-icon class="icon-xs">open_in_new</mat-icon>
    </a>
  </div>
</div>

<form class="mt-4 flex flex-col gap-6" [formGroup]="form">
  <mat-slide-toggle formControlName="testMode">Test Mode</mat-slide-toggle>

  <mat-form-field>
    <mat-label>Account Email</mat-label>
    <input matInput formControlName="email" />
    <mat-hint>
      Enter the email address associated with the practice's Heidi Health
      account
    </mat-hint>
  </mat-form-field>

  <pt-buttons-container>
    <button mat-flat-button color="primary" (click)="save()">Save</button>
  </pt-buttons-container>
</form>
